"use client"

import { useEffect, useState } from "react";
import { FilterAndSorting } from "./FilterAndSorting";
import { ProductList } from "./ProductList";
// import { WebFilter } from "./WebFilter";
import useProductStore from "@/store/productStore";
import { toast } from "@/hooks/use-toast";
import Loader from "../common/loader";
import { useParams, useRouter, useSearchParams } from "next/navigation";
import InfiniteScroll from "../common/InfiniteScroll";
import { createPortal } from "react-dom";
import { FilterModal } from "./FilterModal";
import useCommonStore from "@/store/commonStore";
import { GTMCategoryItemsListHandler } from "@/lib/analytics";

export default function ProductItemComponent() {
    const [filter, setFilter] = useState<Record<string, string[]>>({})
    const [sort, setSort] = useState<Record<string, string>>({})
    const [loading, setLoading] = useState(false)
    const [filterOpen, setFilterOpen] = useState(false)
    const [sortOpen, setSortOpen] = useState(false)
    const [selectedFilterCount, setSelectedFilterCount] = useState(0)
    const [selectedSortCount, setSelectedSortCount] = useState(0)


    const { fetchProducts, productList, productMetadata, loadMoreProducts } = useProductStore()
    const { filterData, fetchCategoryFilters, sortData } = useCommonStore()
    const searchParams = useSearchParams()
      const params = useParams()
    const loadProducts = async (f?: Record<string, string[]>, s?: Record<string, string>) => {
        setLoading(true)
        const result = await fetchProducts({ filter: f, sort: s })

        GTMCategoryItemsListHandler(params?.item_category as string  || "", params?.item_slug as string || "", searchParams.get("id") as string || "")
        setLoading(false)
        if (!result.status) {
            toast({
                variant: "destructive",
                title: "Error",
                description: result.error,
            })
        }
    }
    const filterAndSort = () => {
        const fltr: Record<string, string[]> = {}
        const sort: Record<string, string> = {}
        let f_count = 0
        let s_count = 0
        searchParams?.forEach((value, key) => {
            if (key.startsWith("f_")) {
                f_count += 1
                const filterKey = key.slice(2)
                fltr[filterKey] = value.split('-')
            } else if (key.startsWith("s_")) {
                s_count += 1
                const sortKey = key.slice(2)
                sort[sortKey] = value
            }
        })
        if (searchParams.get("id") && searchParams.get("key")) {
            if (fltr[searchParams.get("key") as string]) {
                fltr[searchParams.get("key") as string]?.push(searchParams.get("id") as string)
            } else {
                fltr[searchParams.get("key") as string] = [searchParams.get("id") as string]
            }
        }
        setSelectedFilterCount(f_count)
        setSelectedSortCount(s_count)
        setFilter(fltr)
        setSort(sort)
        return { fltr, sort }
    }

    useEffect(() => {
        const { fltr: f, sort: s } = filterAndSort()
        fetchCategoryFilters(searchParams.get("id") as string || "")
        loadProducts(f, s)    
    }, [searchParams])

    const router = useRouter()

    const handleApply = (key?: string, value?: string) => {
        const sp = new URLSearchParams()
        searchParams.forEach((v, k) => {
            if (!k.startsWith('s_')) {
                sp.set(k, v)
            }
        })
        if (key && value) {
            sp.set(`s_${key}`, value)
        } else if (key && !value) {
            sp.delete(`s_${key}`)
        } else {
            searchParams.forEach((value, key) => {
                if (key.startsWith('s_')) {
                    sp.delete(key)
                }
            })
        }
        router.replace(`?${sp.toString()}`)
        setSortOpen(false)
    }
    return (
        <>
            <div className="flex gap-3 mb-3 px-2">
                {filterData?.length > 0 && <button
                    onClick={() => setFilterOpen(true)}
                    className="flex items-center gap-2 px-4 py-2 border border-[#ECECEC] rounded-[8px] bg-white shadow-[0_2px_8px_0_rgba(0,0,0,0.03)] text-black font-medium text-base"
                >
                    <img src={`${process.env.NEXT_PUBLIC_ICON_URL}0a67f11a-9435-4af0-ba44-f613cf51a331.svg`} alt="Filter" className="w-5 h-5" />
                    <p className="relative"><span>Filter</span>
                        {selectedFilterCount > 0 && <span className='absolute top-1 -right-4 bg-red-500 text-white font-semibold text-xs rounded-full px-1 rtl:-left-4 rtl:right-auto'>{selectedFilterCount}</span>}
                    </p>
                </button>}
                {sortData?.length > 0 && <button
                    onClick={() => setSortOpen(true)}
                    className="flex items-center gap-2 px-4 py-2 border border-[#ECECEC] rounded-[8px] bg-white shadow-[0_2px_8px_0_rgba(0,0,0,0.03)] text-black font-medium text-base relative"
                >
                    <img src={`${process.env.NEXT_PUBLIC_ICON_URL}4bcd94b8-215f-45cd-8b7e-4c871c9357fa.svg`} alt="Sort" className="w-5 h-5" />
                    <p className="relative"><span>Sort</span>
                        {selectedSortCount > 0 && <span className='absolute top-1 -right-4 bg-red-500 text-white font-semibold text-xs rounded-full px-1 rtl:-left-4 rtl:right-auto'>{selectedSortCount}</span>}
                    </p>
                </button>}
            </div>
            {/* Main Content */}
            <div className="max-w-7xl p-2 mx-auto md:px-4 flex gap-6">

                {/* Product List */}
                <div className="flex-1 mb-10">
                    {/* <div className="font-semibold text-md mb-8">15 items</div> */}
                    {
                        loading ? (
                            <div>
                                <div className="grid grid-cols-2 gap-3">
                                    {Array.from({ length: 21 }).map((_, index) => (
                                        <div key={index} className="animate-pulse bg-gray-200 rounded-md h-48 "></div>
                                    ))}
                                </div>
                            </div>
                        ) : (

                            productList.length > 0 ? (
                                <>
                                    <InfiniteScroll loading={loading} hasMore={productMetadata?.totalPages > productMetadata?.page} loadMore={() => loadMoreProducts({ page: productMetadata?.page + 1, limit: productMetadata?.limit,filter })}>
                                        <ProductList products={productList} />
                                    </InfiniteScroll>
                                </>
                            ) : (
                                <div className="text-center text-gray-300 mt-20">
                                    <p className="text-sm">No products found.</p>
                                </div>
                            )
                        )
                    }
                </div>
                {filterOpen && filterData?.length > 0 && createPortal(
                    <FilterModal
                        open={filterOpen}
                        onClose={() => setFilterOpen(false)}
                    />,
                    document.body
                )}

                {sortOpen && createPortal(
                    <div
                        className={`fixed inset-0 z-50 transition-all duration-700 ease-in-out ${sortOpen ? 'bg-black/40 backdrop-blur-sm' : 'bg-black/0'
                            }`}
                        onClick={() => {
                            setSortOpen(prev => !prev)
                        }}
                    >
                        <div
                            className={`fixed bottom-0 left-0 right-0 bg-white rounded-t-3xl shadow-2xl transform transition-all duration-700 ease-in-out ${sortOpen ? 'translate-y-0 opacity-100 scale-100' : 'translate-y-full opacity-0 scale-95'
                                }`}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div className="w-12 h-1 bg-gray-300 rounded-full mx-auto mt-3 mb-6"></div>
                            <div className="px-4 pb-6">
                                <div className="flex items-center justify-between mb-6">
                                    <h3 className="text-lg font-semibold text-gray-800">Sort By</h3>
                                    <button onClick={() => {
                                        setSortOpen(false)
                                        handleApply()}} 
                                        className="flex items-center text-sm justify-center rounded-full underline text-gray-500 hover:text-gray-700 transition-colors duration-200">Clear</button>
                                </div>
                                <div className="space-y-1 max-h-80 overflow-y-auto">
                                    {sortData.map((option, index) => (
                                        <label key={index} className="flex items-center justify-between py-2 rounded-xl hover:bg-gray-50 cursor-pointer transition-colors duration-200">
                                            <span className="text-base font-medium text-gray-700">{option?.label}</span>
                                            {/* <div className="w-5 h-5 rounded-full border-2 border-gray-300 flex items-center justify-center"> */}
                                                <input
                                                    type="radio"
                                                    name="sort"
                                                    className="w-4 h-4 accent-primary rounded-full"
                                                    checked={sort?.[option.key] === option.value}
                                                    onChange={() => {
                                                        handleApply(option.key, option.value)
                                                    }}
                                                />
                                            {/* </div> */}
                                        </label>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>,
                    document.body
                )}
            </div>
        </>
    )
}